var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.99952H3.41841M3.24603 9.79673L2.24127 12.7981C1.69097 14.4419 1.41582 15.2638 1.61328 15.7699C1.78476 16.2095 2.15305 16.5427 2.60749 16.6696C3.1308 16.8156 3.9212 16.4599 5.50201 15.7486L15.6364 11.1881C17.1794 10.4937 17.9509 10.1466 18.1893 9.66429C18.3965 9.24529 18.3965 8.75366 18.1893 8.33466C17.9509 7.85237 17.1794 7.5052 15.6364 6.81086L5.48452 2.24254C3.90849 1.53333 3.12047 1.17873 2.59768 1.32419C2.14367 1.45052 1.77541 1.78288 1.60334 2.22161C1.40521 2.72679 1.67742 3.54692 2.22184 5.18718L3.24798 8.27881C3.34149 8.56053 3.38824 8.70139 3.4067 8.84545C3.42307 8.97329 3.42291 9.1027 3.4062 9.23049C3.38738 9.37451 3.34026 9.51525 3.24603 9.79673Z",
    stroke: "#11C0F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8fc5d45c27fd44d2988b72e32a69cac1.svg";
export { ForwardRef as ReactComponent };